import Page from './page';
import SafetyDataSheetSearchForm from '../components/orders/safety-data-sheet-search-form';

export default class SafetyDataSheetPage extends Page {

  private readonly form: SafetyDataSheetSearchForm;

  constructor(body: JQuery) {
    super();

    this.form = new SafetyDataSheetSearchForm(body.find('.js-safetyDataSheetForm'));
  }

  init(): void {
    super.init();
  }

}
